import React from 'react';

const HeatmapLegend = () => (
  <span className="heatmap__legend">Legend</span>
);

export default HeatmapLegend;
